export const PAGINATION = {
  INITIAL: 1,
  SECOND: 2,
  MAX_DISPLAY_COUNT: 20,
};
